export enum AuthActions {
  UPDATE_PROFILE = 'AUTH/UPDATE_PROFILE',
  REMOVE_PROFILE = 'AUTH/REMOVE_PROFILE',
}
